<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.class}`"
    :data-type="context.type"
  >
    <p
      v-if="!companyId"
      class="text-muted mb-0"
    >{{ $t('formulateCompanyContactsManager.noCompany') }}</p>
    <company-contacts-manager
      v-else
      :company-id="companyId"
      :read-only="localDisabled"
      :hide-fields="hideFields"
      :no-shadow="noShadow"
    ></company-contacts-manager>
  </div>
</template>

<script>
// a company's contacts, managed right in a flow form (CompanyContactsManager) -- for the backend CompanyContactsInput (renderer key
// 'company_contacts_manager') -- Oct 2026
// an INPUT (not a 'component' form item) so it follows read-only like any other field: a read_only field, or a read-only form (like a
// completed task), shows the contacts without the add / edit / invite actions
// the contacts are saved by CompanyContactsManager as the user works -- this input has no value of its own
import CompanyContactsManager from '@/components/portal/CompanyContactsManager.vue';

export default {
  name: 'FormulateCompanyContactsManager',
  components: {
    CompanyContactsManager,
  },
  i18n: {
    // English only for now -- other languages fall back to English
    messages: {
      en: {
        formulateCompanyContactsManager: {
          noCompany: 'There is no company to show contacts for.',
        },
      },
    },
  },
  props: {
    context: {
      // standard Formulate input context
      type: Object,
      required: true,
    },
    companyId: {
      type: String,
      default: '',
    },
    hideFields: {
      // CompanyContactsManager field keys to hide (full_name, email, job_title, work_location, portal_access, tenant_roles, actions)
      type: Array,
      default: undefined,
    },
    noShadow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localDisabled() {
      return this.context.attributes?.disabled ?? this.context.disabled ?? false;
    },
  },
};
</script>
